import style from './form-position.scss';
import formPosition from 'Assets//js/form-position-behavior';

const script = () => {
  const cssClass: string = 'FormPosition';
  formPosition({
    targetCss: `.${cssClass}`,
    targetForm: `.${cssClass}-trueForm`,
    targetInputLat: `.${cssClass}-lat`,
    targetInputLng: `.${cssClass}-lng`,
  });

  // Drupal call
  formPosition({
    targetCss: `.ListCirfa .views-exposed-form`,
    targetForm: `.views-exposed-form`,
    targetInputLat: `[data-drupal-selector="edit-geoloc-lat"]`,
    targetInputLng: `[data-drupal-selector="edit-geoloc-lng"]`,
    labelTag: 'h2',
  });
};

export {
  style,
  script,
};
